const DEFAULT_GESTOCK_STORE_ID = "69ca7b777bb1cc108ef9666e";
const DEFAULT_GESTOCK_API_ORIGIN = "https://api.mediiq.app";

function trimTrailingSlash(value: string) {
  return value.replace(/\/+$/, "");
}

function normalizeGestockApiBaseUrl(value: string) {
  const trimmed = trimTrailingSlash(String(value || "").trim());
  if (!trimmed) return "";
  if (trimmed.endsWith("/api/gestock")) return trimmed;
  return `${trimmed}/api/gestock`;
}

function decodeBase64UrlToHex(value: string) {
  if (!/^[A-Za-z0-9\-_]+$/.test(value)) return "";

  try {
    const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
    const binary = window.atob(padded);
    const hex = Array.from(binary)
      .map((char) => char.charCodeAt(0).toString(16).padStart(2, "0"))
      .join("");

    return hex.length === 24 ? hex : "";
  } catch {
    return "";
  }
}

export function getGestockStoreId() {
  const explicitStoreId = String(process.env.REACT_APP_GESTOCK_STORE_ID || "").trim();
  if (explicitStoreId) return explicitStoreId;

  const storefrontIdentifier = String(
    process.env.REACT_APP_GESTOCK_STOREFRONT_ID || ""
  ).trim();
  if (storefrontIdentifier) {
    return decodeBase64UrlToHex(storefrontIdentifier) || storefrontIdentifier;
  }

  return DEFAULT_GESTOCK_STORE_ID;
}

export function getGestockApiBaseUrl() {
  const configuredBaseUrl = String(
    process.env.REACT_APP_GESTOCK_API_BASE_URL || ""
  ).trim();

  if (configuredBaseUrl) {
    return normalizeGestockApiBaseUrl(configuredBaseUrl);
  }

  return normalizeGestockApiBaseUrl(DEFAULT_GESTOCK_API_ORIGIN);
}
